export const saveSnapshot = (data) => {
    //data = {snapshot}
    return { type: "SAVE_SNAPSHOT", payload: data }
}

export const undo = (data) => {
    //data = {lastState}
    return { type: "UNDO", payload: data }
}

export const setUndoAttempts = (data) => {
    //data = {attempts}
    return { type: "SET_UNDO_ATTEMPTS", payload: data }
}
